import BrandingSettingsPage from './branding-settings-page';

export function BrandingRouter() {
  return <BrandingSettingsPage />;
}
